import React from 'react';
import PropTypes from 'prop-types';
import './Checkbox.scss';

const types = ['checkbox', 'radio'];

function Checkbox(props) {
    const { type, label, onChange, checked, ...inputProps } = props;
    const inputType = type && types.indexOf(type) !== -1 ? type : 'checkbox';

    return (
        <label className='r-checkbox'>
            <input
                type={inputType}
                className='visually-hidden'
                onChange={onChange}
                checked={checked}
                {...inputProps}
            />
            <span className='r-checkbox__icon ico'>
                <svg width='18' height='18'>
                    <use xlinkHref='#check-icon' href='#check-icon'></use>
                </svg>
            </span>
            {label ? <span className='r-checkbox__label'>{label}</span> : null}
        </label>
    );
}

Checkbox.propTypes = {};
Checkbox.defaultProps = {};

export default Checkbox;
